import {classes} from '@bitstillery/common/lib/utils'
import {unique_id} from '@bitstillery/common/lib/utils'
import {MithrilComponent} from '@bitstillery/mithril'
import {modelref_adapter, modelref_assign} from '@bitstillery/common/lib/store'
import {Icon} from '@bitstillery/common/components/ui/icon/icon'
import m from '@bitstillery/mithril'

import type {FieldRadioSelectionAttrs} from '@bitstillery/common/types/field'
import {failure_message} from '@bitstillery/common/lib/validation'

export class FieldRadioSelection extends MithrilComponent<FieldRadioSelectionAttrs> {
    name = unique_id()

    view(vnode: m.Vnode<FieldRadioSelectionAttrs>) {
        const {validation} = vnode.attrs
        const invalid = validation ? validation._invalid : false
        // Add human readable description to the validation object.
        if (validation && vnode.attrs.label) {
            validation.description = vnode.attrs.label
        }

        const {model_value, model_ref} = modelref_adapter(vnode.attrs.model)

        return (
            <div
                className={classes('c-field-radio-selection', 'field', vnode.attrs.className, {
                    disabled: vnode.attrs.disabled,
                    invalid: validation && invalid && validation.dirty,
                    valid: !validation || !invalid,
                })}
            >
                {vnode.attrs.label && (
                    <label>
                        {vnode.attrs.label}
                        {vnode.attrs.icon && <Icon name={vnode.attrs.icon} />}
                        {validation && <span className='validation'>{validation.label}</span>}
                    </label>
                )}
                <div data-toggle='buttons' className='btn-group'>
                    {vnode.attrs.choices.map((choice) => {
                        const is_selected = model_value === choice.value
                        return (
                            <label
                                key={choice.value}
                                className={classes(is_selected ? 'btn btn-info' : 'btn btn-default', {
                                    disabled: vnode.attrs.disabled,
                                })}
                                onclick={() => {
                                    if (vnode.attrs.disabled) {
                                        return
                                    }
                                    if (vnode.attrs.validation) {
                                        vnode.attrs.validation.dirty = true
                                    }
                                    if (model_ref) {
                                        modelref_assign(model_ref, choice.value)
                                    }
                                    if (vnode.attrs.onchange) {
                                        vnode.attrs.onchange(choice.value)
                                    }
                                    if (vnode.attrs.onAfterChange) {
                                        vnode.attrs.onAfterChange(choice.value)
                                    }
                                }}
                                title={choice.title}
                            >
                                <input
                                    type='radio'
                                    name={this.name}
                                    autocomplete='off'
                                    checked={is_selected}
                                    disabled={vnode.attrs.disabled}
                                />
                                {choice.description}
                            </label>
                        )
                    })}
                </div>
                {(() => {
                    if (invalid && validation?.dirty) {
                        return <div className='help validation'>{failure_message(invalid)}</div>
                    } else if (vnode.attrs.help) {
                        return <div class='help'>{vnode.attrs.help}</div>
                    }
                    return undefined
                })()}
            </div>
        )
    }
}
